import { render } from "./RefuelingsTable.vue?vue&type=template&id=66d3bbf9"
import script from "./RefuelingsTable.vue?vue&type=script&lang=ts"
export * from "./RefuelingsTable.vue?vue&type=script&lang=ts"
script.render = render

export default script